// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1TOhg","bigColWidth":"Table_bigColWidth__hKcTz","biggerColWidth":"Table_biggerColWidth__3LXlT","row":"Table_row__24Ozj","col":"Table_col__1Supn"};